/* eslint-disable no-irregular-whitespace */

import { Head, Navbar, Footer } from './sections'

export default `
<html data-wf-page="6187c4ffefcbe9f42740d790" data-wf-site="617aeb5a738d7f6b279e7a99">
${Head}
<body class="bg-neutral-800">
  <div style="opacity:0" class="page-wrapper">
    ${Navbar}
    <section class="section pricing wf-section">
      <div class="container-small-590px pricing">
        <h1 data-w-id="421cdd75-997d-4914-747c-6710591816a4"
          style="-webkit-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40%, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="title pricing">Pricing</h1>
        <p data-w-id="6429b458-c4f6-6657-4a67-82a0faff99d6"
          style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="paragraph pricing">To commemorate the launch of Collabski, it&#x27;s 100% free to sign up and sponsor
          vetted creators!</p>
      </div>
      <div class="container-default pricing w-container">
        <div data-w-id="5b7b798c-3bee-f3c0-046b-659a4d9fefe2"
          style="-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);opacity:0"
          class="pricing-collection-list-wrapper w-dyn-list">
          <div role="list" class="pricing-wrapper w-dyn-items">
            <div role="listitem" class="pricing-plan-item w-dyn-item">
              <div class="card-plan-item-popular-gradient-blur"></div>
              <a href="/signup" class="card plan-item w-inline-block">
                <div class="card-plan-item-content">
                  <div class="card-plan-item-content-top">
                    <div class="card-plan-item-title-wrapper">
                      <h2 class="title h3-size card-plan-item">Launch Pricing</h2>
                    </div>
                  </div>
                  <div class="card-plan-item-content-bottom">
                    <div class="w-layout-grid card-plan-item-features-grid">
                      <div class="card-plan-item-feature-wrapper">
                        <div class="card-plan-item-feature-icon-wrapper"><img
                            src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-1-check-dark-template.svg"
                            loading="eager" alt="" class="image card-plan-item-feature-icon" /></div>
                        <div class="card-plan-item-feature-text">Vetted creators</div>
                      </div>
                      <div class="card-plan-item-feature-wrapper">
                        <div class="card-plan-item-feature-icon-wrapper"><img
                            src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-1-check-dark-template.svg"
                            loading="eager" alt="" class="image card-plan-item-feature-icon" /></div>
                        <div class="card-plan-item-feature-text">Unlimited sponsorships</div>
                      </div>
                      <div class="card-plan-item-feature-wrapper">
                        <div class="card-plan-item-feature-icon-wrapper"><img
                            src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-1-check-dark-template.svg"
                            loading="eager" alt="" class="image card-plan-item-feature-icon" /></div>
                        <div class="card-plan-item-feature-text">Management dashboard</div>
                      </div>
                      <div class="card-plan-item-feature-wrapper">
                        <div class="card-plan-item-feature-icon-wrapper"><img
                            src="https://d2vh08r8g1sliz.cloudfront.net/landing/icon-1-check-dark-template.svg"
                            loading="eager" alt="" class="image card-plan-item-feature-icon" /></div>
                        <div class="card-plan-item-feature-text">Learning resources</div>
                      </div>
                    </div>
                    <div class="card-plan-item-button-wrapper">
                      <div class="button-primary-gradient full-width plan">
                        <div class="button-primary small">Free to use</div>
                      </div>
                      <div class="paragraph-small card-plan-item-content-bottom-small-print">No credit card required
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <div class="space card-plan-item-popular"></div>
            </div>
          </div>
        </div>
        <div class="bg-gradient-blur-wrapper pricing">
          <div class="bg-gradient-blur-circle-3 pink top"></div>
          <div class="bg-gradient-blur-circle-1 purple"></div>
        </div>
      </div>
      <div class="container-default pricing w-container"></div>
    </section>
    ${Footer}
  </div>
  <script src="https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=617aeb5a738d7f6b279e7a99"
    type="text/javascript" integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=" crossorigin="anonymous">
    </script>
  <script src="/landing/js/webflow.min.js" type="text/javascript"></script>
  <!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->
</body>
</html>
`
